/*global $*/
import React from "react";
import { connect } from "react-redux";

import { goTo } from "../tools";
import { validarEmail, getNombre } from "./services.act.js";
import { authentication } from "../app-database";
import { preguntas } from "../properties";

const mapState = (state) => {
	return {
		secreto: state.login.secreto,
		error: state.login.error,
		mensaje: state.login.errorMsj,
		loader: state.global.loader
	};
};

const mapDispatch = (dispatch) => {
	return {
		pasoSiguiente: (correo) => {
			//dispatch({ "type": "LOGIN_PASO_SIGUIENTE" });
			dispatch(getNombre(correo));
		},
		setCorreo: (correo) => {
			dispatch({ "type": "LOGIN_SET_CORREO", "correo": correo});
		},
		setSecreto: (secreto) => {
			dispatch({"type": "LOGIN_SET_SECRETO", "secreto": secreto});
		},
		setPreguntaUno: (obj) => {
			dispatch({ "type": "LOGIN_SET_PREGUNTA_UNO", texto: obj.t, id: obj.id});
		},
		setPreguntaDos: (obj) => {
			dispatch({ "type": "LOGIN_SET_PREGUNTA_DOS", texto: obj.t, id: obj.id});
		},
		showLoader: () => {
			dispatch({ "type": "LOADER_SHOW"});
		},
		clearError: () => {
			dispatch({ "type": "LOGIN_SET_ERROR", "error": false, "errorMsj": ""});
		}
	};
};

class IngresaCorreo extends React.Component {
	state = {
		inputType: "password",
		inputClass: "input-wrap ver-input mt-70",
		inputActive: "",
		error: false,
		errorMsj: "",
		email: "",
		bloqueado: false
	}

	validateEmail = (email) => {
		var pattern = /^(([^<>()\[\]\.,;:\s@\"]+(\.[^<>()\[\]\.,;:\s@\"]+)*)|(\".+\"))@(([^<>()[\]\.,;:\s@\"]+\.)+[^<>()[\]\.,;:\s@\"]{2,})$/i;
		return pattern.test(email);
	}
	changeInputType = () => {
		let type = this.state.inputType;
		this.setState({inputType: type == "password" ? "text" : "password"});
		this.setState({inputClass: type == "password" ? "input-wrap visible-input mt-70" : "input-wrap ver-input mt-70"});
	}
	validarEmail = () => {
		this.setState({bloqueado: true});
		if(!this.props.loader && !this.state.bloqueado){
			console.log("Entro a Validar Email");
			let email = $("#correo-login").val();
			if(!email) {
				this.setState({error: true});
				this.setState({errorMsj: "Campo requerido."});
				this.setState({bloqueado: false});
				return;
			} else if(!this.validateEmail(email)) {
				this.setState({error: true});
				this.setState({errorMsj: "Formato de correo inválido. Intenta nuevamente."});
				this.setState({bloqueado: false});
				return;
			}
			else {
				this.props.setCorreo(email);
				this.props.showLoader();
				this.props.setPreguntaUno({t: "aoehanotehanotehn", id: "aoeaoe"});
				this.props.setPreguntaDos({t: "aoehanotehanotehn", id: "aoeaoe"});
				this.setState({bloqueado: false});
				this.props.pasoSiguiente(email);
			}
		}
	}
	handleBlur = (event) => {
		let mail = event.target.value.replace(/\s/g,"");
		this.setState({email: mail});
		this.setState({inputActive: mail ? "input-active" : ""});
		this.setState({error: false});
		this.setState({errorMsj: ""});
		this.props.clearError();
		let email = event.target.value;
		/*if(!email) {
				this.setState({error: true});
				this.setState({errorMsj: "Campo requerido."});
				this.setState({bloqueado: false});
			} else */
		if(email.length >1 && !this.validateEmail(email)) {
			this.setState({error: true});
			this.setState({errorMsj: "Formato de correo inválido. Intenta nuevamente."});
			this.setState({bloqueado: false});
		}
	}
	handleFocus = (event) => {
		this.setState({inputActive: "input-active"});
		//event.target.value = this.state.error ? "" : event.target.value.replace(/\s/g,'');
		this.setState({error: false});
		this.setState({errorMsj: ""});
		this.props.clearError();
		let email = event.target.value;
		/*if(!email) {
				this.setState({error: true});
				this.setState({errorMsj: "Campo requerido."});
				this.setState({bloqueado: false});
			} else*/ 
		if(email.length >1 && !this.validateEmail(email)) {
			this.setState({error: true});
			this.setState({errorMsj: "Formato de correo inválido. Intenta nuevamente."});
			this.setState({bloqueado: false});
		}
	}
	_handleKeyPress = (event) => {
		
		if (event.key === "Enter") {
			if(!this.state.bloqueado) {
				console.log("Entro al enter 1");
				this.setState({bloqueado: true});
				this.validarEmail();
			}
		}
	}
	
	ir = (sRuta) => {
		goTo(sRuta);
	}

	render() {
		return <div className="login-form">
			<div className="login-logo">
				<img src={ require("../img/logo-gnp.svg") } alt="" />
			</div>
			<div className="login-form mt-70">
				<h3>Iniciar sesión</h3>
				<div className={this.state.inputClass}>
					<label>Correo electrónico</label>
					<span className={this.state.inputActive}>
						<input id="correo-login" aria-label="Correo electronico" name="correo" type={this.state.inputType} onBlur={this.handleBlur} onFocus={this.handleFocus} onKeyPress={this._handleKeyPress} />
						<button aria-label="Ver correo" name="continuar" className="btn-ojo" onClick={this.changeInputType} >
							<i></i>
						</button>
					</span>
					{ this.state.error &&
						<div className="error-wrap">
							<div className="msj-error">
								<p>{this.state.errorMsj}</p>
							</div>
						</div>
					}
					{ this.props.error &&
						<div className="error-wrap">
							<div className="msj-error">
								<p>{this.props.mensaje}</p>
							</div>
						</div>
					}
				</div>
				<button aria-label="Continuar" ref="boton" onClick={this.validarEmail} disabled={this.state.bloqueado} className="orange-circle">
					<i></i>
				</button>
			</div>
			{/*REDIRECCION A NUEVO REGISTRO Y LOGIN*/}
			<div className="text-center other-actions">
				<a onClick={this.ir.bind(this, "registro")} name="registro" className="orange-btn">Registrarse</a>
				<a onClick={this.ir.bind(this, "olvide")} name="olvide">Olvidé mi contraseña</a>
			</div>
		</div>;
	}
}

export default connect(mapState, mapDispatch)(IngresaCorreo);



// WEBPACK FOOTER //
// ./src/login/ingresaCorreo.cmpt.js